import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import PropTypes from 'prop-types';
import { ChildrenPropType } from '../../services/proptypes';
var propTypes = {
  totalNumberOfItems: PropTypes.number.isRequired,
  autoScroll: PropTypes.bool,
  autoScrollTime: PropTypes.number,
  numberOfDisplayItems: PropTypes.number,
  children: ChildrenPropType.isRequired
};
var defaultProps = {
  autoScroll: false,
  autoScrollTime: 5000,
  numberOfDisplayItems: 3
};
var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);
  var _super = _createSuper(Carousel);
  function Carousel(props) {
    var _this;
    _classCallCheck(this, Carousel);
    _this = _super.call(this, props);
    _this.state = {
      currentIndex: 0
    };
    _this.autoScrollTimer = null;
    _this.getDisplayItemIndices = _this.getDisplayItemIndices.bind(_assertThisInitialized(_this));
    _this.changeCurrentIndex = _this.changeCurrentIndex.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startAutoScrollTimerInterval();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearAutoScrollTimerInterval();
    }
  }, {
    key: "getDisplayItemIndices",
    value: function getDisplayItemIndices() {
      var _this$props = this.props,
        numberOfDisplayItems = _this$props.numberOfDisplayItems,
        totalNumberOfItems = _this$props.totalNumberOfItems;
      var currentIndex = this.state.currentIndex;
      var displayIndices = new Array(numberOfDisplayItems).fill(currentIndex).map(function (i, index) {
        return (i + index) % totalNumberOfItems;
      });
      return displayIndices;
    }
  }, {
    key: "setCurrentIndex",
    value: function setCurrentIndex(index) {
      var resetInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var totalNumberOfItems = this.props.totalNumberOfItems;
      if (resetInterval) {
        // to avoid moving to the next image right just after the user clicked on a indicator
        this.startAutoScrollTimerInterval();
      }
      this.setState({
        currentIndex: index % totalNumberOfItems
      });
    }
  }, {
    key: "startAutoScrollTimerInterval",
    value: function startAutoScrollTimerInterval() {
      var _this2 = this;
      var _this$props2 = this.props,
        autoScroll = _this$props2.autoScroll,
        autoScrollTime = _this$props2.autoScrollTime,
        totalNumberOfItems = _this$props2.totalNumberOfItems;
      this.clearAutoScrollTimerInterval();
      if (autoScroll && totalNumberOfItems > 1) {
        this.autoScrollTimer = setInterval(function () {
          return _this2.incrementCurrentIndex();
        }, autoScrollTime);
      }
    }
  }, {
    key: "clearAutoScrollTimerInterval",
    value: function clearAutoScrollTimerInterval() {
      if (this.autoScrollTimer) {
        clearInterval(this.autoScrollTimer);
        this.autoScrollTimer = null;
      }
    }
  }, {
    key: "changeCurrentIndex",
    value: function changeCurrentIndex(index) {
      var totalNumberOfItems = this.props.totalNumberOfItems;
      if (index < 0) {
        this.setCurrentIndex(totalNumberOfItems - 1, true);
      } else if (index === totalNumberOfItems) {
        this.setCurrentIndex(0, true);
      } else {
        this.setCurrentIndex(index, true);
      }
    }
  }, {
    key: "incrementCurrentIndex",
    value: function incrementCurrentIndex() {
      var currentIndex = this.state.currentIndex;
      this.setCurrentIndex(currentIndex + 1);
    }
  }, {
    key: "render",
    value: function render() {
      var currentIndex = this.state.currentIndex;
      var children = this.props.children;
      var childProps = {
        currentIndex: currentIndex,
        getDisplayItemIndices: this.getDisplayItemIndices,
        changeCurrentIndex: this.changeCurrentIndex
      };
      return children(childProps);
    }
  }]);
  return Carousel;
}(React.Component);
export { Carousel as default };
Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;